import { Chevron } from '@ahamove/icons';
import { Group, Stack, Text, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import BikePackageIcon from '@/assets/icons/bike-package-icon.svg';
import InfoTooltip from '@/components/info-tooltip';

interface TruckBulkyPackageHeaderProps {
  isOpen: boolean;
  onToggle: () => void;
}

const TruckBulkyPackageHeader = ({
  isOpen,
  onToggle,
}: TruckBulkyPackageHeaderProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Group
      justify="space-between"
      className="relative w-full cursor-pointer"
      onClick={onToggle}
      gap={0}
      wrap="nowrap"
      p="md"
    >
      <BikePackageIcon className="size-6 md:size-8" viewBox="0 0 32 32" />

      <Stack gap={4} className="mx-3 grow overflow-hidden">
        {/* <Group gap={8} wrap="nowrap"> */}
        {/* <Stack gap={4} className="overflow-hidden"> */}
        <Title
          className="mx-3 grow overflow-hidden"
          order={isMobile ? 6 : 4}
          lineClamp={1}
          style={{
            cursor: 'pointer',
          }}
        >
          <Text fw={700} size={isMobile ? 'sm' : 'lg'}>
            Thông tin hàng hóa
          </Text>
        </Title>
        {/* </Stack> */}
        {/* </Group> */}
      </Stack>

      <Chevron
        style={{
          flex: 'none',
          transform: isOpen ? 'rotate(-90deg)' : 'rotate(90deg)',
          transition: 'transform 200ms ease',
        }}
        className="size-4 shrink-0 md:size-6"
      />
    </Group>
  );
};

export default TruckBulkyPackageHeader;
